import type React from 'react';
import { SteamLoginButton } from '../components/SteamLoginButton';

export const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-indigo-100">
            <svg
              className="h-6 w-6 text-indigo-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Financial Costpoint Management
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in to access your financial dashboard
          </p>
        </div>

        <div className="mt-8 space-y-6">
          <div className="bg-white py-8 px-6 shadow rounded-lg sm:px-10">
            <div className="text-center">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Authentication Required</h3>
              <p className="text-sm text-gray-600 mb-6">
                Please sign in with your Steam account to access the financial management system.
              </p>

              <SteamLoginButton className="w-full" />

              <div className="mt-6">
                <div className="relative">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-300" />
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="px-2 bg-white text-gray-500">
                      Secure authentication via Steam
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-6 text-xs text-gray-500">
                <p>
                  By signing in, you agree to access the financial management system in accordance
                  with your assigned role and permissions.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center">
            <div className="text-sm text-gray-600">
              <p className="font-medium">Role-Based Access:</p>
              <ul className="mt-2 space-y-1 text-xs">
                <li>
                  <span className="font-medium">Viewer:</span> Read-only access to financial data
                </li>
                <li>
                  <span className="font-medium">Operator:</span> Import transactions and manage
                  budgets
                </li>
                <li>
                  <span className="font-medium">Budget Creator:</span> Create and edit budgets
                </li>
                <li>
                  <span className="font-medium">Admin:</span> User management and full system access
                </li>
                <li>
                  <span className="font-medium">Super Admin:</span> Complete system control
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
